import { render, staticRenderFns } from "./sportClubForm.vue?vue&type=template&id=641def6e&scoped=true&"
import script from "./sportClubForm.vue?vue&type=script&lang=js&"
export * from "./sportClubForm.vue?vue&type=script&lang=js&"
import style0 from "./sportClubForm.vue?vue&type=style&index=0&id=641def6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641def6e",
  null
  
)

export default component.exports